export default __webpack_public_path__ + "img/pin_icons/sliding_door_w.svg";